import { connect } from 'react-redux';
import { getCurrentUser } from '../../../publicSession/selectors';
import { pushAwardBadgeModal } from '../../redux/actionCreators';
const mapStateToProps = (state, props)=>({
        isOwner: getCurrentUser(state).userId === props.recipient.user.userId
    });
const mapDispatchToProps = {
    onAwardClick: pushAwardBadgeModal
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=AwardsPopup.container.js.map